<template>
    <div class="mypooq-inner-wrap" v-if="!isLoading">
      <my-pooq-type v-if="dataMypooqType" :data="dataMypooqType" :is-loading="isLoading"/>
      <graph-type v-if="dataMypooqType && dataMypooqType.type" :dataDevice="dataDeviceList"/>
      <analysis-program-list v-if="dataMypooqType && dataMypooqType.type && dataProgramList" :dataList="dataProgramList"/>
      <analysis-vod-person v-if="dataMypooqType && dataMypooqType.type && dataPersonList" :dataList="dataPersonList"/>
      <analysis-channel-list v-if="dataMypooqType && dataMypooqType.type && dataChannelList" :dataList="dataChannelList"/>
    </div>
</template>

<script>
import MyPooqType from '@/components/mypooq/MyPooqType'
import GraphType from '@/components/mypooq/GraphType'
import AnalysisProgramList from '@/components/mypooq/AnalysisProgramList'
import AnalysisVodPerson from '@/components/mypooq/AnalysisVodPerson'
import AnalysisChannelList from '@/components/mypooq/AnalysisChannelList'
import { getAnalysisLists, getAnalysisIntro } from '@/common/utils/request'
import _ from 'lodash'
export default {
  components: {
    MyPooqType,
    GraphType,
    AnalysisProgramList,
    AnalysisVodPerson,
    AnalysisChannelList
  },
  data () {
    return {
      dataMypooqType: {},
      dataProgramList: [],
      dataPersonList: [],
      dataChannelList: [],
      dataTagList: [],
      dataDeviceList: [],
      isLoading: true
    }
  },
  computed: {
    ieVersion () {
      let word
      const agent = navigator.userAgent.toLowerCase()
      // IE old version ( IE 10 or Lower )
      if (navigator.appName === 'Microsoft Internet Explorer') word = 'msie '
      // IE 11
      else if (agent.search('trident') > -1) word = 'trident/.*rv:'
      // Microsoft Edge
      else if (agent.search('edge/') > -1) word = 'edge/'
      // 그외, IE가 아니라면 ( If it's not IE or Edge )
      else return -1
      let reg = new RegExp(word + '([0-9]{1,})(\\.{0,}[0-9]{0,1})')
      if (reg.exec(agent) != null) return parseFloat(RegExp.$1 + RegExp.$2)
      return -1
    }
  },
  created () {
    this.isLoading = true
    getAnalysisIntro().then(({ data }) => {
      this.dataMypooqType = data
      this.isLoading = false
    })

    getAnalysisLists().then((response) => {
      response.data.forEach(data => {
        const list = _.get(data, 'list', [])
        switch (data.type) {
          case 'analysisprogramlist':
            this.dataProgramList = list.slice(0, 10)
            break
          case 'analysisvodpersonlist':
            this.dataPersonList = list.slice(0, 12)
            break
          case 'analysischannellist':
            this.dataChannelList = list.slice(0, 12)
            break
          case 'analysistaglist':
            if (this.ieVersion === -1 || this.ieVersion > 10) {
              this.dataTagList = list.slice(0, 20)
            }
            break
          case 'analysisdevicelist':
            this.dataDeviceList = list
            break
          default:
            break
        }
      })
    })
  }
}
</script>
